import { render, staticRenderFns } from "./DialogPushInsurance.vue?vue&type=template&id=478a5994&scoped=true&"
import script from "./DialogPushInsurance.vue?vue&type=script&lang=js&"
export * from "./DialogPushInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "478a5994",
  null
  
)

export default component.exports